import { ButtonTooltip } from '../types/connection-types';

export const addConnectionTooltip = (isReadOnlyRole: boolean) => {
  return isReadOnlyRole
    ? ButtonTooltip.ReadOnlyUser
    : ButtonTooltip.AddConnection;
};

export const saveConnectionTooltip = (isReadOnlyRole: boolean) => {
  return isReadOnlyRole
    ? ButtonTooltip.ReadOnlyUser
    : ButtonTooltip.SaveConnection;
};

export const removeConnectionTooltip = (
  isReadOnlyRole: boolean,
  isSelfConnection: boolean,
) => {
  return isReadOnlyRole
    ? ButtonTooltip.ReadOnlyUser
    : isSelfConnection
    ? ButtonTooltip.SelfConnection
    : ButtonTooltip.RemoveConnection;
};
